import { render, staticRenderFns } from "./BenefitsWeb.vue?vue&type=template&id=4c71f0f2&scoped=true"
import script from "./BenefitsWeb.vue?vue&type=script&lang=js"
export * from "./BenefitsWeb.vue?vue&type=script&lang=js"
import style0 from "./BenefitsWeb.vue?vue&type=style&index=0&id=4c71f0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c71f0f2",
  null
  
)

export default component.exports